/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Toggle_ThemeInputs */

const en_common_toggle_theme = /** @type {(inputs: Common_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

const es_common_toggle_theme = /** @type {(inputs: Common_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar tema`)
};

/**
* | output |
* | --- |
* | "Toggle theme" |
*
* @param {Common_Toggle_ThemeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_toggle_theme = /** @type {((inputs?: Common_Toggle_ThemeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Toggle_ThemeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_toggle_theme(inputs)
	return es_common_toggle_theme(inputs)
});